// @ts-nocheck
import { createReducer } from 'reduxsauce';
import produce from 'immer';
import { Types } from '../actions/resource_code';
import { Types as costCodeTypes } from '../actions/cost_code';

const initialState = {
  showTemplateDrawer: false,
  success: false,
  formFields: {
    name: '',
    description: '',
    status: '',
    is_default: false,
    other_properties: [],
  },
  templateConfirmationModal: {
    show: false,
    templateId: null,
  },
  templatePagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    pageNumber: 1,
  },
  templateSort: {
    orderBy: 'updated_at',
    orderType: '',
  },
  templates: [],
  currentTemplate: {},
  latestCreatedTemplateId: null,
  showResourceCodeDrawer: false,
  resourceCodeFormFields: {
    resource_name: '',
    resource_code: '',
    cost_code: '',
    cost_code_code: '',
    minimum_order_quantity: '',
    rate: '',
    unit: '',
    description: '',
    other_properties: {},
    is_default: false,
    last_updated: new Date(),
  },
  confirmationModal: {
    show: false,
    resourceCodeId: null,
  },
  pagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    pageNumber: 1,
  },
  sort: {
    orderBy: 'updated_at',
    orderType: '',
  },
  noteModal: {
    show: false,
    noteId: null,
    notes: [],
    message: '',
    resourceCodeId: null,
    mode: null,
  },
  alertModal: {
    show: false,
    uuid: null,
    // noteId: null,
    // notes: [],
    // message: '',
    // resourceCodeId: null,
    // mode: null,
    // resource_name: '',
    // resource_code: '',
    // cost_code: '',
    // minimum_order_quantity: '',
    // rate: '',
    // unit: '',
    // other_properties: {},
    // is_default: false,
    // last_updated: new Date(),
  },
  dynamicFieldFormFields: {
    name: '',
    type: '',
  },
  showDynamicFieldDrawer: false,
  dynamicFieldConfirmationModal: {
    show: false,
    uuid: null,
  },
  resourceCodes: [],
  costCodeOptions: [],
  resourceTypeOptions: [],
};

const getCostCodesSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  return {
    ...state,
    costCodeOptions: data.map((costCode) => ({
      label: costCode.cost_code,
      value: costCode.id,
    })),
  };
};

const getResourceTypeSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  return {
    ...state,
    resourceTypeOptions: data.map((resourceType) => ({
      label: resourceType.name,
      value: resourceType.id,
    })),
  };
};

const openTemplateDrawer = (state) => ({
  ...state,
  showTemplateDrawer: true,
});

const closeTemplateDrawer = (state) => ({
  ...state,
  showTemplateDrawer: false,
});

const resetTemplateFormFields = (state) => ({
  ...state,
  formFields: initialState.formFields,
});

const updateTemplateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    formFields: {
      ...state.formFields,
      [name]: value,
    },
  };
};

const createTemplateSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.is_default) {
    return {
      ...state,
      templates: produce(state.templates, (draft) => {
        const defaultTemplate = draft.find(
          (defaultTemplate) => defaultTemplate.is_default,
        );
        if (defaultTemplate) {
          defaultTemplate.is_default = false;
        }
        draft.push(data);
      }),
    };
  }
  return {
    ...state,
    templates: [...state.templates, data],
  };
};

const getTemplatesSuccess = (state, action) => {
  const {
    payload: { data, total_pages, total },
  } = action;
  return {
    ...state,
    success: true,
    templates: data,
    templatePagination: {
      ...state.templatePagination,
      totalPages: total_pages,
      total,
    },
  };
};

const getTemplateSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    currentTemplate: data,
    success: true,
  };
};

const setLatestTemplateId = (state, action) => {
  const {
    payload: { id },
  } = action;
  return {
    ...state,
    latestCreatedTemplateId: id,
  };
};

const openActionOptionDrawer = (state) => ({
  ...state,
  showActionOptionDrawer: true,
});

const closeActionOptionDrawer = (state) => ({
  ...state,
  showActionOptionDrawer: false,
  latestCreatedTemplateId: null,
});

const editTemplate = (state, action) => ({
  ...state,
  formFields: { ...action.payload },
  showTemplateDrawer: true,
});

const updateTemplateSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  return {
    ...state,
    templates: produce(state.templates, (draft) => {
      const index = draft.findIndex((template) => template.id === data.id);
      const resetDefault = draft.find(
        (template) => template.is_default === true,
      );
      draft.splice(
        draft.findIndex((template) => template.is_default === true),
        1,
        { ...resetDefault, is_default: false },
      );
      draft.splice(index, 1, data);
    }),
  };
};

const openTemplateConfirmationModal = (state, action) => {
  const {
    payload: { templateId },
  } = action;
  return {
    ...state,
    templateConfirmationModal: {
      show: true,
      templateId,
    },
  };
};

const closeTemplateConfirmationModal = (state) => ({
  ...state,
  templateConfirmationModal: initialState.templateConfirmationModal,
});

const deleteTemplateSuccess = (state) => {
  const {
    templateConfirmationModal: { templateId },
  } = state;

  return {
    ...state,
    templates: state.templates.filter(
      (template) => template.id !== +templateId,
    ),
  };
};

const cloneTemplateSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  return {
    ...state,
    templates: [...state.templates, data],
  };
};

const updateTemplatePageNumber = (state, action) => {
  const {
    payload: { pageNumber },
  } = action;
  return {
    ...state,
    templatePagination: {
      ...state.templatePagination,
      pageNumber,
    },
  };
};

const updateTemplatePerPage = (state, action) => {
  const clonedPagination = { ...state.templatePagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    templatePagination: clonedPagination,
  };
};

export const updateTemplateSortFields = (state, action) => ({
  ...state,
  templateSort: action.payload,
});

const openResourceCodeDrawer = (state) => ({
  ...state,
  showResourceCodeDrawer: true,
});

const closeResourceCodeDrawer = (state) => ({
  ...state,
  showResourceCodeDrawer: false,
});

const resetResourceCodeFormFields = (state) => ({
  ...state,
  resourceCodeFormFields: initialState.resourceCodeFormFields,
});

const updateResourceCodeFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  if (name === 'cost_code') {
    return {
      ...state,
      resourceCodeFormFields: {
        ...state.resourceCodeFormFields,
        [name]: value.value,
        cost_code_code: value?.label,
      },
    };
  }
  if (name === 'resource_type') {
    return {
      ...state,
      resourceCodeFormFields: {
        ...state.resourceCodeFormFields,
        [name]: value.value,
        resource_type_name: value?.label,
      },
    };
  }
  return {
    ...state,
    resourceCodeFormFields: {
      ...state.resourceCodeFormFields,
      [name]: value,
    },
  };
};

const updateResourceCodeDynamicFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    resourceCodeFormFields: {
      ...state.resourceCodeFormFields,
      other_properties: {
        ...state.resourceCodeFormFields.other_properties,
        [name]: value,
      },
    },
  };
};

const createResourceCodeSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      resourceCodes: produce(state.resourceCodes, (draft) => {
        const defaultResourceCode = draft.find(
          (resourceCode) => resourceCode.default,
        );
        if (defaultResourceCode) {
          defaultResourceCode.default = false;
        }
        draft.push(data);
      }),
    };
  }
  return {
    ...state,
    resourceCodes: [...state.resourceCodes, data],
  };
};

const getResourceCodesSuccess = (state, action) => {
  const {
    payload: { data, total_pages, total },
  } = action;
  return {
    ...state,
    resourceCodes: data,
    pagination: {
      ...state.pagination,
      totalPages: total_pages,
      total,
    },
  };
};

const editResourceCode = (state, action) => ({
  ...state,
  resourceCodeFormFields: { ...action.payload },
  showResourceCodeDrawer: true,
});

const updateResourceCodeSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      resourceCodes: produce(state.resourceCodes, (draft) => {
        const defaultTemplate = draft.find((costCode) => costCode.default);
        if (defaultTemplate) {
          defaultTemplate.default = false;
        }
        const index = draft.findIndex((costCode) => costCode.id === data.id);
        draft.splice(index, 1, data);
      }),
    };
  }

  return {
    ...state,
    resourceCodes: produce(state.resourceCodes, (draft) => {
      const index = draft.findIndex((costCode) => costCode.id === data.id);
      draft.splice(index, 1, data);
    }),
  };
};

const openConfirmationModal = (state, action) => {
  const {
    payload: { resourceCodeId },
  } = action;
  return {
    ...state,
    confirmationModal: {
      show: true,
      resourceCodeId,
    },
  };
};

const closeConfirmationModal = (state) => ({
  ...state,
  confirmationModal: initialState.confirmationModal,
});

const deleteResourceCodeSuccess = (state) => {
  const {
    confirmationModal: { resourceCodeId },
  } = state;

  return {
    ...state,
    resourceCodes: state.resourceCodes.filter(
      (resourceCode) => resourceCode.id !== +resourceCodeId,
    ),
  };
};

const updatePageNumber = (state, action) => {
  const {
    payload: { pageNumber },
  } = action;
  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageNumber,
    },
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = { ...state.pagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    pagination: clonedPagination,
  };
};

export const updateSortFields = (state, action) => ({
  ...state,
  sort: action.payload,
});

const openNoteModal = (state, action) => {
  const {
    payload: { resourceCodeId, notes },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      show: true,
      resourceCodeId,
      notes,
    },
  };
};

const closeNoteModal = (state) => ({
  ...state,
  noteModal: initialState.noteModal,
});

const updateNoteMessage = (state, action) => {
  const {
    payload: { message },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      message,
    },
  };
};

const createNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { resourceCodeId },
  } = state;
  return {
    ...state,
    resourceCodes: produce(state.resourceCodes, (draft) => {
      const selectedResourceCode = draft.find(
        (resourceCode) => resourceCode.id === +resourceCodeId,
      );
      selectedResourceCode.notes.push(data);
    }),
  };
};

const editNote = (state, action) => {
  const {
    payload: { noteId, message, mode },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      noteId,
      message,
      mode,
      notes: [],
    },
  };
};

const updateNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { noteId, resourceCodeId },
  } = state;

  return {
    ...state,
    resourceCodes: produce(state.resourceCodes, (draft) => {
      const selectedResourceCode = draft.find(
        (resourceCode) => resourceCode.id === +resourceCodeId,
      );

      const index = selectedResourceCode.notes.findIndex(
        (note) => note.id === +noteId,
      );
      selectedResourceCode.notes.splice(index, 1, data);
    }),
  };
};

const deleteNoteSuccess = (state, action) => {
  const {
    payload: { noteId },
  } = action;
  const {
    noteModal: { resourceCodeId },
  } = state;

  return {
    ...state,
    resourceCodes: produce(state.resourceCodes, (draft) => {
      const selectedResourceCode = draft.find(
        (resourceCode) => resourceCode.id === +resourceCodeId,
      );

      const index = selectedResourceCode.notes.findIndex(
        (note) => note.id === +noteId,
      );
      selectedResourceCode.notes.splice(index, 1);
    }),
    noteModal: {
      ...state.noteModal,
      notes: state.noteModal.notes.filter((note) => note.id !== +noteId),
    },
  };
};

// const openAlertModal = (state, action) => {
//   const {
//     // payload: {},
//   } = action;

//   return {
//     ...state,
//     // noteModal: {
//     //   ...state.noteModal,
//     //   show: true,
//     //   resourceCodeId,
//     //   notes,
//     // },
//   };
// };

// const closeAlertModal = (state) => ({
//   ...state,
//   alertModal: initialState.alertModal,
// });

// const updateAlertModal = (state, action) => {
//   const {
//     // payload: {},
//   } = action;

//   return {
//     ...state,
//     alertModal: {
//       ...state.alertModal,
//       // message,
//     },
//   };
// };

const openAlertModal = (state, action) => {
  const {
    payload: { alert },
  } = action;
  return {
    ...state,
    alertModal: {
      show: true,
      message: alert,
      // uuid,
    },
  };
};

const closeAlertModal = (state) => ({
  ...state,
  alertModal: {
    show: false,
    // uuid: null,
  },
});

const openDynamicFieldDrawer = (state, action) => {
  const {
    payload: { type, fromImportPage },
  } = action;

  return {
    ...state,
    showDynamicFieldDrawer: true,
    dynamicFieldFormFields: {
      ...state.dynamicFieldFormFields,
      type,
      fromImportPage,
    },
  };
};

const closeDynamicFieldDrawer = (state) => ({
  ...state,
  showDynamicFieldDrawer: false,
  dynamicFieldFormFields: initialState.dynamicFieldFormFields,
});

const updateDynamicFieldFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    dynamicFieldFormFields: {
      ...state.dynamicFieldFormFields,
      [name]: value,
    },
  };
};

const addDynamicFieldSuccess = (state, action) => ({
  ...state,
  currentTemplate: action.payload.data,
});

const editDynamicField = (state, action) => {
  const {
    payload: { property },
  } = action;
  return {
    ...state,
    showDynamicFieldDrawer: true,
    dynamicFieldFormFields: { ...property },
  };
};

const openDynamicFieldConfirmationModal = (state, action) => {
  const {
    payload: { uuid },
  } = action;
  return {
    ...state,
    dynamicFieldConfirmationModal: {
      show: true,
      uuid,
    },
  };
};

const closeDynamicFieldConfirmationModal = (state) => ({
  ...state,
  dynamicFieldConfirmationModal: {
    show: false,
    uuid: null,
  },
});

const deleteDynamicFieldSuccess = (state, action) => ({
  ...state,
  currentTemplate: action.payload.data,
  resourceCodes: state.resourceCodes.map((resourceCode) => ({
    ...resourceCode,
    other_properties: action.payload.data.other_properties.reduce(
      (acc, property) => {
        acc[property.uuid] = resourceCode.other_properties[property.uuid];
        return acc;
      },
      {},
    ),
  })),
});

const resourceCodeReducer = createReducer(initialState, {
  [costCodeTypes.GET_COST_CODES_SUCCESS]: getCostCodesSuccess,
  [Types.GET_RESOURCE_TYPE_SUCCESS]: getResourceTypeSuccess,

  [Types.OPEN_TEMPLATE_DRAWER]: openTemplateDrawer,
  [Types.CLOSE_TEMPLATE_DRAWER]: closeTemplateDrawer,
  [Types.RESET_TEMPLATE_FORM_FIELDS]: resetTemplateFormFields,
  [Types.UPDATE_TEMPLATE_FORM_FIELD]: updateTemplateFormField,
  [Types.CREATE_TEMPLATE_SUCCESS]: createTemplateSuccess,
  [Types.GET_TEMPLATES_SUCCESS]: getTemplatesSuccess,
  [Types.GET_TEMPLATE_SUCCESS]: getTemplateSuccess,
  [Types.SET_LATEST_TEMPLATE_ID]: setLatestTemplateId,
  [Types.OPEN_ACTION_OPTION_DRAWER]: openActionOptionDrawer,
  [Types.CLOSE_ACTION_OPTION_DRAWER]: closeActionOptionDrawer,
  [Types.EDIT_TEMPLATE]: editTemplate,
  [Types.UPDATE_TEMPLATE_SUCCESS]: updateTemplateSuccess,
  [Types.OPEN_TEMPLATE_CONFIRMATION_MODAL]: openTemplateConfirmationModal,
  [Types.CLOSE_TEMPLATE_CONFIRMATION_MODAL]: closeTemplateConfirmationModal,
  [Types.DELETE_TEMPLATE_SUCCESS]: deleteTemplateSuccess,
  [Types.CLONE_TEMPLATE_SUCCESS]: cloneTemplateSuccess,
  [Types.UPDATE_TEMPLATE_PAGE_NUMBER]: updateTemplatePageNumber,
  [Types.UPDATE_TEMPLATE_PER_PAGE]: updateTemplatePerPage,
  [Types.UPDATE_TEMPLATE_SORT_FIELDS]: updateTemplateSortFields,

  [Types.OPEN_RESOURCE_CODE_DRAWER]: openResourceCodeDrawer,
  [Types.CLOSE_RESOURCE_CODE_DRAWER]: closeResourceCodeDrawer,
  [Types.RESET_RESOURCE_CODE_FORM_FIELDS]: resetResourceCodeFormFields,
  [Types.UPDATE_RESOURCE_CODE_FORM_FIELD]: updateResourceCodeFormField,
  [Types.UPDATE_RESOURCE_CODE_DYNAMIC_FORM_FIELD]:
    updateResourceCodeDynamicFormField,
  [Types.CREATE_RESOURCE_CODE_SUCCESS]: createResourceCodeSuccess,
  [Types.GET_RESOURCE_CODES_SUCCESS]: getResourceCodesSuccess,
  [Types.EDIT_RESOURCE_CODE]: editResourceCode,
  [Types.UPDATE_RESOURCE_CODE_SUCCESS]: updateResourceCodeSuccess,
  [Types.OPEN_CONFIRMATION_MODAL]: openConfirmationModal,
  [Types.CLOSE_CONFIRMATION_MODAL]: closeConfirmationModal,
  [Types.DELETE_RESOURCE_CODE_SUCCESS]: deleteResourceCodeSuccess,
  [Types.UPDATE_PAGE_NUMBER]: updatePageNumber,
  [Types.UPDATE_PER_PAGE]: updatePerPage,
  [Types.UPDATE_SORT_FIELDS]: updateSortFields,
  [Types.OPEN_NOTE_MODAL]: openNoteModal,
  [Types.CLOSE_NOTE_MODAL]: closeNoteModal,
  [Types.UPDATE_NOTE_MESSAGE]: updateNoteMessage,
  [Types.OPEN_ALERT_MODAL]: openAlertModal,
  [Types.CLOSE_ALERT_MODAL]: closeAlertModal,
  // [Types.UPDATE_ALERT_MESSAGE]: updateAlertModal,
  [Types.CREATE_NOTE_SUCCESS]: createNoteSuccess,
  [Types.EDIT_NOTE]: editNote,
  [Types.UPDATE_NOTE_SUCCESS]: updateNoteSuccess,
  [Types.DELETE_NOTE_SUCCESS]: deleteNoteSuccess,
  [Types.OPEN_DYNAMIC_FIELD_DRAWER]: openDynamicFieldDrawer,
  [Types.CLOSE_DYNAMIC_FIELD_DRAWER]: closeDynamicFieldDrawer,
  [Types.UPDATE_DYNAMIC_FIELD_FORM_FIELD]: updateDynamicFieldFormField,
  [Types.ADD_DYNAMIC_FIELD_SUCCESS]: addDynamicFieldSuccess,
  [Types.EDIT_DYNAMIC_FIELD]: editDynamicField,
  [Types.OPEN_DYNAMIC_FIELD_CONFIRMATION_MODAL]:
    openDynamicFieldConfirmationModal,
  [Types.CLOSE_DYNAMIC_FIELD_CONFIRMATION_MODAL]:
    closeDynamicFieldConfirmationModal,
  [Types.DELETE_DYNAMIC_FIELD_SUCCESS]: deleteDynamicFieldSuccess,
});

export default resourceCodeReducer;
